import { createContext, useCallback, useContext, useState, useTransition } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const NavigationContext = createContext(null);

export const NavigationProvider = ({ children }) => {
  const [isPending, startTransition] = useTransition();
  const history = useHistory();

  const navigate = useCallback((path, state) => {
    startTransition(() => {
      history.push(path, state);
    });
  }, [history, startTransition]);

  return (
    <NavigationContext.Provider value={{ navigate, isPending }}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => useContext(NavigationContext);